import { Suspense, lazy } from "react";
import { Outlet, ScrollRestoration } from "react-router";

import { LOGOUT_LOADER } from "@application/loaders/logout_loader";

import { Loader } from "@styled/loader";

import { DASHBOARD_ROUTE } from "./dashboard/route";
import { Home } from "./home";
import { Login } from "./login";

const Demo = lazy(() => import("./demo").then((m) => ({ default: m.Demo })));
const DemoThanks = lazy(() =>
  import("./demo/thanks").then((m) => ({ default: m.DemoThanks })),
);
const Invitation = lazy(() =>
  import("./invitation").then((m) => ({ default: m.Invitation })),
);
const ResetConfirm = lazy(() =>
  import("./reset_confirm").then((m) => ({ default: m.ResetConfirm })),
);
const ResetRequest = lazy(() =>
  import("./reset_request").then((m) => ({ default: m.ResetRequest })),
);
const Signup = lazy(() =>
  import("./signup").then((m) => ({ default: m.Signup })),
);
const Verify = lazy(() =>
  import("./verify").then((m) => ({ default: m.Verify })),
);

export const ROUTES = [
  {
    element: (
      <>
        <ScrollRestoration />
        <Outlet />
      </>
    ),
    // Paints while ME_LOADER and the first route loader are still in flight;
    // #root has no height, so the wrapper centres the spinner in the viewport.
    hydrateFallbackElement: (
      <div className="h-screen">
        <Loader />
      </div>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
        index: true,
      },
      {
        path: "invitations/:sid?",
        element: (
          <Suspense fallback={<Loader />}>
            <Invitation />
          </Suspense>
        ),
      },
      {
        path: "verify/:sid?",
        element: (
          <Suspense fallback={<Loader />}>
            <Verify />
          </Suspense>
        ),
      },
      {
        path: "reset",
        element: (
          <Suspense fallback={<Loader />}>
            <ResetRequest />
          </Suspense>
        ),
      },
      {
        // Also serves /reset/confirm.
        path: "reset/:sid",
        element: (
          <Suspense fallback={<Loader />}>
            <ResetConfirm />
          </Suspense>
        ),
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "signup",
        element: (
          <Suspense fallback={<Loader />}>
            <Signup />
          </Suspense>
        ),
      },
      {
        path: "demo",
        element: (
          <Suspense fallback={<Loader />}>
            <Demo />
          </Suspense>
        ),
      },
      {
        path: "demo/thanks",
        element: (
          <Suspense fallback={<Loader />}>
            <DemoThanks />
          </Suspense>
        ),
      },
      {
        path: "logout",
        loader: LOGOUT_LOADER,
      },
      DASHBOARD_ROUTE,
    ],
  },
];
